import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_DESPESASGERAIS_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterTodos(filtro) {
        return axiosJwt
            .get(
                `${api}/despesasgerais/demandantes/pagamentos?situacao=${filtro.situacao}&status=${filtro.status}&dataInicial=${filtro.dataInicial}&dataFinal=${filtro.dataFinal}`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterPorId(pagamentoId) {
        return axiosJwt
            .get(`${api}/despesasgerais/demandantes/pagamentos/${pagamentoId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    downloadPagamentoAnexo(pagamentoAnexoId) {
        return axiosJwt
            .get(`${api}/despesasgerais/demandantes/pagamentos/anexos/${pagamentoAnexoId}/baixar`, {
                responseType: 'blob'
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterAnexos(pagamentoId) {
        return axiosJwt
            .get(
                `${api}/despesasgerais/demandantes/pagamentos/${pagamentoId}/anexos`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterTimeLine(pagamentoId) {
        return axiosJwt
            .get(`${api}/despesasgerais/demandantes/pagamentos/${pagamentoId}/timeline`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }
}